export default __webpack_public_path__ + "static/media/190629_190332_IMG_2602.02135b66.jpg";